import React from "react";
import { UscLabel } from "../../../../../utils/labels";
import Button from "../../../../../../shared-components/toyota/styles/atoms/Button";
import Icon from "../../../../../../shared-components/toyota/styles/atoms/Icon";
import * as Styles from "./UscPersonaliseFinanceButton.styles";

export type UscPersonaliseFinanceButtonProps = {
    onClick?: () => void;
};

const UscPersonaliseFinanceButton = ({ onClick }: UscPersonaliseFinanceButtonProps): JSX.Element => (
    <Styles.Wrapper>
        <Button variant="icon-text" textUnderline onClick={onClick} size="small">
            <Icon variant="financing" />
            <UscLabel label="uscBasketPersonaliseFinance" />
        </Button>
    </Styles.Wrapper>
);

export default UscPersonaliseFinanceButton;
